/**
 * Image Banner
 * @summary A custom element that uses the intersection observer to animate image/content in
 * @extends HTMLElement
 */
if (!customElements.get('image-banner')) {
  class ImageBanner extends HTMLElement {
    constructor() {
      super();

      this.animateContent = this.getAttribute('data-content-animate');
      this.animateImage = this.getAttribute('data-image-animate');
    }

    connectedCallback() {
      if (this.animateContent || this.animateImage) {
        this.initIntersectionObserver();
      }
    }

    initIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };

      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
      this.observer.observe(this);
    }

    handleIntersect(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (this.animateContent) {
            this.classList.add('content-animate-in');
          }

          if (this.animateImage) {
            this.classList.add('image-animate-in');
          }
          this.observer.unobserve(this);
        }
      });
    }
  }

  customElements.define('image-banner', ImageBanner);
}
